import { initDevice } from './modules/devicesHandler.js';
import { padLeft } from './modules/common.js';
import { More } from './modules/components.js';

// import { heroCarousel } from './modules/heroImg-carousel.js';
import { heroCarousel } from './modules/heroImg-carousel.js';
import { LinkedCarousel } from './modules/carousel.js';

import { initBannerTextFade } from './modules/bannerTextFade.js';
import { initYoutubeVolumeControl } from './modules/youtubeVolumeControl.js';

// data 
import {
	heroImg,
	constructionProjectInfos,
	lotValueInfos,
	advantagesInfos,
	featureInfos,
	landscapeInfos,
	mastersInfos,
	thelaluInfos
} from './modules/indexData.js';
// ==========

initDevice();

// 註冊 GSAP ScrollTrigger (建議在 main.js 顯式註冊一次，雖然 CDN 可能會自動處理)
if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
	gsap.registerPlugin(ScrollTrigger);
}

// initBannerTextFade();

// 批量掛載到 window
const globals = {
	padLeft,
	More,
};

Object.assign(window, globals);


/**
 * 2. 主程式邏輯 (DOM Ready 後執行)
 */
document.addEventListener('DOMContentLoaded', () => {
	// --- A. 初始化 Petite Vue ---
	initVueApp();
	hidePreloadWhenHeroReady().then(() => {
		initLazyLoad();
	});

	// 等待 Vue DOM 渲染完成
	setTimeout(() => {
		// 1. 初始化 Hero 輪播
		heroCarousel();

		// 2. 初始化 通用圖文輪播
		initAllCarousels();

		// 3. 初始化 文字特效
		initBannerTextFade();
	}, 0);
});

async function hidePreloadWhenHeroReady() {
	const preload = document.querySelector('#preload');
	const hero = document.querySelector('.hero-img');

	await new Promise(resolve => requestAnimationFrame(resolve));

	const images = hero ? Array.from(hero.querySelectorAll('img')) : [];
	await Promise.all(images.map(image => {
		if (image.complete) return Promise.resolve();

		return new Promise(resolve => {
			image.addEventListener('load', resolve, { once: true });
			image.addEventListener('error', resolve, { once: true });
		});
	}));
	if (!preload) return;

	preload.style.transition = 'opacity 0.3s ease';
	preload.style.opacity = '0';
	preload.addEventListener('transitionend', () => preload.remove(), { once: true });
	setTimeout(() => preload.remove(), 350);
}

function loadDeferredElement(element) {
	const picture = element.closest('picture');
	picture?.querySelectorAll('source[data-srcset]').forEach(source => {
		source.srcset = source.dataset.srcset;
		source.removeAttribute('data-srcset');
	});

	if (element.dataset.src) {
		element.src = element.dataset.src;
		element.removeAttribute('data-src');
	}

	if (element.dataset.bg) {
		const background = element.dataset.bgMobile && window.innerWidth <= 1200
			? element.dataset.bgMobile
			: element.dataset.bg;

		element.style.backgroundImage = `url('${background}')`;
		element.removeAttribute('data-bg');
		element.removeAttribute('data-bg-mobile');
	}

	if (element.id === 'youtube-player') {
		initYoutubeVolumeControl();
	}
}

function initLazyLoad() {
	const elements = document.querySelectorAll('[data-src], [data-bg]');

	if (!('IntersectionObserver' in window)) {
		elements.forEach(loadDeferredElement);
		return;
	}

	const observer = new IntersectionObserver(entries => {
		entries.forEach(entry => {
			if (!entry.isIntersecting) return;

			loadDeferredElement(entry.target);
			observer.unobserve(entry.target);
		});
	}, {
		rootMargin: '300px 0px',
		threshold: 0.01,
	});

	elements.forEach(element => observer.observe(element));
}

/**
 * [函式提取] 初始化 Petite Vue
 */
function initVueApp() {
	if (!window.PetiteVue) {
		console.error('❌ Petite Vue not found. Check CDN.');
		return;
	}

	window.PetiteVue.createApp({
		// 1. 注入全域函式
		...globals,

		// 2. 資料綁定 (從 window 讀取 PHP 輸出的資料，若無則給空陣列防呆)

		constructionProjectInfos: constructionProjectInfos || [],
		heroImg: heroImg || [],

		lotValueInfos: lotValueInfos || [],
		advantagesInfos: advantagesInfos || [],
		featureInfos: featureInfos || [],
		landscapeInfos: landscapeInfos || [],
		mastersInfos: mastersInfos || [],
		thelaluInfos: thelaluInfos || []
	}).mount();

	console.log('✅ Petite Vue mounted.');
}

// 涵式定義

function initAllCarousels() {

	// 1. 定義標準圖文連動區塊的 Class 清單 (配置驅動)
	// 若未來有新區塊，只需在此陣列加入 class 名稱即可
	const carouselScopes = [
		'.construction-project',
		'.lot-value',
		'.advantages',
		'.features',
		'.masters',
		'.thelalu'
	];

	// 2. 批量初始化標準連動輪播
	carouselScopes.forEach(scope => {
		// 檢查該區塊是否存在，避免無效初始化 (LinkedCarousel 內部也有防呆，但這裡檢查更乾淨)
		if (document.querySelector(scope)) {
			new LinkedCarousel(
				`${scope} .text-side`,        // 文字區
				`${scope} .img-side`,         // 圖片區
				// 使用逗號分隔兩個選擇器
				`${scope} .text-side .control button, ${scope} .img-side .control-mobile button`,

				// --- 修正重點：同時選取 電腦版分頁 與 手機版分頁 ---
				`${scope} .text-side .controls-dots, ${scope} .img-side .controls-dots-mobile`
			);
		}
	});

	// 3. 初始化特殊區塊 (Landscape) - 僅圖片，無文字連動

	initLandscapeCarousel();

	console.log('✅ All Carousels initialized.');
}
// ============

/**
 * Landscape 特殊輪播
 */
function initLandscapeCarousel() {
	const landscapeSelector = '.landscape .img-side';
	const landscapeEl = document.querySelector(landscapeSelector);

	if (landscapeEl && window.Swiper) {
		new window.Swiper(landscapeSelector, {
			loop: true,
			loopedSlides: 3,
			// 取消滑鼠拖曳
			grabCursor: false,
			allowTouchMove: false,
			// ======
			slidesPerView: 1,
			centeredSlides: true,
			// 起始索引 0 是第一張
			initialSlide: 0,
			parallax: true,
			spaceBetween: 0,
			speed: 1000,
			watchSlidesProgress: true,
			autoplay: {
				delay: 5000,
				disableOnInteraction: false,
			},
			// 滾動輪播控制
			mousewheel: false,
			// mousewheel: {
			// 	thresholdDelta: 50,
			// },
			navigation: { nextEl: '.landscape .swiper-next-button' },
			pagination: {
				el: '.landscape .controls-dots',
				clickable: true,
				// 自定義圓點樣式
				renderBullet: function (index, className) {
					return `<li class="${className}"></li>`;
				}
			},

		});
	}
}
